module.exports = __webpack_public_path__ + "media/images/pic/family-2-752d43488604c6356cd4b995a13f0d32.jpeg";